module.exports = __webpack_public_path__ + "assets/active-slide-template-active.bb723ab6.svg";